export type ApiReachability = "unknown" | "reachable" | "unreachable";

export interface ApiNetworkSnapshot {
  reachability: ApiReachability;
  lastUpdatedAt: number | null;
  lastFailureAt: number | null;
  lastErrorCode: string | null;
}

type Listener = () => void;

let snapshot: ApiNetworkSnapshot = {
  reachability: "unknown",
  lastUpdatedAt: null,
  lastFailureAt: null,
  lastErrorCode: null
};

const listeners = new Set<Listener>();

function publish(next: ApiNetworkSnapshot) {
  snapshot = next;
  for (const listener of listeners) listener();
}

export function getApiNetworkSnapshot(): ApiNetworkSnapshot {
  return snapshot;
}

export function subscribeToApiNetwork(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function recordApiSuccess(at = Date.now()): void {
  publish({
    reachability: "reachable",
    lastUpdatedAt: at,
    lastFailureAt: snapshot.lastFailureAt,
    lastErrorCode: null
  });
}

export function recordApiReachable(): void {
  publish({
    ...snapshot,
    reachability: "reachable",
    lastErrorCode: null
  });
}

export function recordApiFailure(code: string, at = Date.now()): void {
  publish({
    ...snapshot,
    reachability: "unreachable",
    lastFailureAt: at,
    lastErrorCode: code
  });
}

export function resetApiNetworkStatusForTests(): void {
  snapshot = {
    reachability: "unknown",
    lastUpdatedAt: null,
    lastFailureAt: null,
    lastErrorCode: null
  };
  listeners.clear();
}
